import React from "react";
import Badge from "react-bootstrap/Badge";

export const activeStatus = ["active", "inactive", "expiring", "expired"];

const ClaimItemStatus = (props) => {
  const { status = "" } = props;
  let statusBadge = "info";
  let claimStatus = "submitted";

  switch (status) {
    case 1:
      statusBadge = "default";
      break;
    case 2:
      statusBadge = "warning";
      claimStatus = "processing";
      break;
    case 3:
      statusBadge = "danger";
      claimStatus = "declined";
      break;
    case 4:
      // additional info required from client
      statusBadge = "info";
      claimStatus = "info required";
      break;
    case 5:
      statusBadge = "info";
      claimStatus = "cheque written";
      break;
    case 6:
      statusBadge = "success";
      claimStatus = "paid";
      break;
    default:
      statusBadge = "default";
      claimStatus = "opened";
      break;
  }
  let widget = <Badge className={`bg-${statusBadge}`}>{claimStatus}</Badge>;
  return widget;
};

export default ClaimItemStatus;
